import { render, staticRenderFns } from "./DebtActions.vue?vue&type=template&id=245e50c8&"
import script from "./DebtActions.vue?vue&type=script&lang=js&"
export * from "./DebtActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports